export enum FeedbackRating {
  Up = 0,
  Down = 1,
}
